/** Keeps queued QuantisAI messages from outliving the chat they were written
 *  in. Sending one upserts its conversation on the server, so a queued
 *  message for a deleted chat would bring the chat back, and its uploads
 *  went with the chat. */
import type { SIOutbox } from './SIMessageQueue';

// Module scope, not component state: outboxes of other panels sit in the
// cache and are only dispatched once their panel mounts again.
const deletedConversations = new Set<string>();

export function forgetSIConversation(conversationId: string): void {
  deletedConversations.add(conversationId);
}

export function isForgottenSIConversation(conversationId: string | undefined): boolean {
  return Boolean(conversationId && deletedConversations.has(conversationId));
}

/** A paused queue with nothing left has nothing to resume. */
export function withoutConversation(outbox: SIOutbox, conversationId: string): SIOutbox {
  const messages = outbox.messages.filter(item => item.conversationId !== conversationId);
  if (messages.length === outbox.messages.length) return outbox;
  return { messages, paused: outbox.paused && messages.length > 0 };
}
